<mat-card data-at-firmware-update-modal>
  <ng-container *ngrxLet="firmwareUpdateStore.isInUpdateTimeblock$ as isInUpdateTimeblock">
    <mat-card-header>
      <mat-card-title>
        {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.CHECK_TIME_BLOCK.TITLE' | translate }}
      </mat-card-title>
    </mat-card-header>
    <ng-container
      *ngIf="
        (firmwareUpdateStore.showFirmwareUpdateStart$ | async) && startConstraints;
        else loader
      "
    >
      <!-- Success state -->
      <ng-container *ngIf="startConstraints.canProceed">
        <mat-card-content>
          <p>
            {{
              isInUpdateTimeblock
                ? ('+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.CHECK_TIME_BLOCK.SUCCESS_DESCRIPTION'
                  | translate)
                : ('+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.CHECK_TIME_BLOCK.FAILED_DESCRIPTION'
                  | translate)
            }}
          </p>
        </mat-card-content>
        <mat-card-actions class="!flex flex-row lt-md:flex-col gap-3 justify-end !items-end">
          <!-- Close button -->
          <ng-container *ngTemplateOutlet="closeButton"></ng-container>

          <!-- Continue button: only for time block issue -->
          <ng-container *ngTemplateOutlet="continueButton"></ng-container>
        </mat-card-actions>
      </ng-container>

      <!-- Failure state -->
      <ng-container *ngIf="!startConstraints.canProceed">
        <mat-card-content>
          <p>
            {{ conditionsNotMetLabel }}
          </p>
        </mat-card-content>
        <mat-card-actions class="!flex flex-row lt-md:flex-col gap-3 justify-end items-center">
          <!-- Close button -->
          <ng-container *ngTemplateOutlet="closeButton"></ng-container>
        </mat-card-actions>
      </ng-container>
    </ng-container>

    <ng-template #loader>
      <vi-loader data-at-loader [isLoading]="true" [message]="null"></vi-loader>
    </ng-template>

    <ng-template #continueButton>
      <div
        class="flex flex-col gap-2 items-center"
        *ngIf="startConstraints.isSoftwareCorrect && startConstraints.isGatewayAllowed"
      >
        <!-- Notification when updating outside timeblock -->
        <p *ngIf="!isInUpdateTimeblock" class="text-xs font-bold">
          {{
            '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.CHECK_TIME_BLOCK.RISK_ACCEPTANCE'
              | translate
          }}
        </p>
        <button
          data-at-firmware-update-modal-next
          mat-raised-button
          color="primary"
          class="connection-button fill-btn flex flex-row justify-center items-center lt-md:order-1"
          (click)="checkUpdateVerification()"
          [disabled]="firmwareUpdateStore.isLoading$ | async"
        >
          <ng-container *ngIf="!(firmwareUpdateStore.isLoading$ | async); else spinner">
            <span>{{
              '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.CHECK_TIME_BLOCK.CONNECT_TO_BACKEND_BTN'
                | translate
            }}</span>
            <mat-icon>arrow_forward</mat-icon>
          </ng-container>
          <ng-template #spinner>
            <span>{{
              '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.CHECK_TIME_BLOCK.CHECKING_CONNECTION'
                | translate
            }}</span>
            <mat-spinner></mat-spinner>
          </ng-template>
        </button>
      </div>
    </ng-template>

    <ng-template #closeButton>
      <button
        data-at-firmware-update-modal-close
        mat-raised-button
        color="primary"
        class="fill-btn lt-md:order-2"
        (click)="onCancel()"
      >
        {{ 'GENERAL.BUTTON.CLOSE' | translate }}
      </button>
    </ng-template>
  </ng-container>
</mat-card>
